// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"442":"75759f56","449":"95f9af04","698":"39e7c3a0"}[chunkId] + ".js";
};